var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "flex flex-col relative",
    on: {
      "mouseenter": _vm.displayLabelTooltipOnHover,
      "mouseleave": _vm.forceHideTooltipLabel
    }
  }, [_c('div', {
    staticClass: "relative h-0"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "duration-300",
      "enter-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "duration-300",
      "leave-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.tooltipLabel && _vm.libelle != null,
      expression: "tooltipLabel && libelle != null"
    }]
  }, [_c('div', {
    staticClass: "tooltip-Label flex absolute rounded-lg shadow-lg text-xs z-50 py-5 px-6 bottom-3 right-0 w-max-content w-max max-w-64 md:max-w-72 xxl:max-w-128",
    class: _vm.backgroundColor + ' ' + _vm.textColor,
    attrs: {
      "name": _vm.name
    },
    domProps: {
      "innerHTML": _vm._s(_vm.libelle)
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row"
  }, [_vm._t("libelleBefore"), _vm._v(" "), _vm.libelle != null ? _c('div', {
    directives: [{
      name: "clickOutside",
      rawName: "v-clickOutside",
      value: _vm.forceHideTooltipLabel,
      expression: "forceHideTooltipLabel"
    }],
    staticClass: "cursor-pointer",
    on: {
      "click": _vm.displayLabelTooltip
    }
  }, [_c('icon', {
    class: _vm.iconPosition + ' ' + _vm.iconColor,
    attrs: {
      "name": _vm.icon
    }
  })], 1) : _vm._e()], 2), _vm._v(" "), _vm._t("tooltipLibelleBefore")], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }